module.exports = __webpack_public_path__ + "static/img/welcome.c394d178.png";